import FW from '../fw/fw';
import Logger from '../fw/logger';
import ListHelpers from './list-helpers';


export default class Playlist {

  #rmp;
  #playlistOnSrcChangedLoadAdFn = null;
  #playlistOnSrcChangeErrorFn = null;
  #filteredPlaylistList = [];
  #currentPlaylistIndex = 0;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get playlistList() {
    return this.#filteredPlaylistList;
  }

  get currentPlaylistIndex() {
    return this.#currentPlaylistIndex;
  }

  #playlistOnSrcChangedLoadAd() {
    this.#rmp.off('srcchanged', this.#playlistOnSrcChangedLoadAdFn);
    this.#rmp.off('error', this.#playlistOnSrcChangeErrorFn);
    this.#rmp.dispatch('playlistitemloaded');
    if (FW.isValidCCFiles(this.#rmp.ccFiles)) {
      this.#rmp.captionsList = this.#rmp.ccFiles;
    }
    if (this.#rmp.playlistCallback === null && this.#rmp.ads && this.#rmp.adTagUrl) {
      this.#rmp.loadAds(this.#rmp.adTagUrl, ['internal']).catch(error => {
        this.#rmp.rmpUtils.warning(1020, error);
        this.#rmp.rmpUtils.playPromise();
      });
    }
    if (this.#rmp.chaptersLoc) {
      this.#rmp.chapters = this.#rmp.chaptersLoc;
    }
  }

  #playlistOnSrcChangeError() {
    this.#rmp.off('srcchanged', this.#playlistOnSrcChangedLoadAdFn);
    this.#rmp.off('error', this.#playlistOnSrcChangeErrorFn);
  }

  #updatePlaylistActiveUI(index) {
    const playlistItems = this.#rmp.dom.playlistContainer.querySelectorAll('.rmp-playlist-item');
    if (playlistItems.length > 0) {
      for (let i = 0, len = playlistItems.length; i < len; i++) {
        playlistItems[i].classList.remove('rmp-playlist-item-active');
      }
      if (playlistItems[index]) {
        playlistItems[index].classList.add('rmp-playlist-item-active');
      }
    }
  }

  #setPlaylistSrcWithOptionalDrm(newItem) {
    if (typeof newItem.shakaRequestConfiguration === 'object') {
      this.#rmp.shakaRequestFilterConfiguration = newItem.shakaRequestConfiguration;
    }
    if (typeof newItem.shakaDrm === 'object') {
      if (typeof newItem.shakaRequestConfiguration === 'undefined') {
        this.#rmp.shakaRequestFilterConfiguration = {};
      }
      this.#rmp.shakaDrmConfiguration = newItem.shakaDrm;
    }
    this.#rmp.setSrc(newItem.src).catch(error => {
      this.#rmp.rmpUtils.warning(1025, error);
    });
  }

  #loadInternalPlaylistItem(index) {
    // new item to load is out of bound return
    if (typeof this.#filteredPlaylistList[index] === 'undefined') {
      return;
    }
    this.#currentPlaylistIndex = index;
    const newItem = this.#filteredPlaylistList[this.#currentPlaylistIndex];
    ListHelpers.listParsing.call(this.#rmp, newItem);
    this.#updatePlaylistActiveUI(this.#currentPlaylistIndex);
    // player  has not received a user interation yet 
    // just update src otherwise setSrc 
    if (!this.#rmp.rmpPlaybackManagement.playerInitialized) {
      this.#setPlaylistSrcWithOptionalDrm(newItem);
    } else {
      this.#rmp.on('srcchanged', this.#playlistOnSrcChangedLoadAdFn);
      this.#rmp.on('error', this.#playlistOnSrcChangeErrorFn);
      this.#setPlaylistSrcWithOptionalDrm(newItem);
    }
    if (newItem.seekBarThumbnailsLoc) {
      this.#rmp.thumbnails = newItem.seekBarThumbnailsLoc;
    } else if (this.#rmp.rmpThumbnails) {
      this.#rmp.rmpThumbnails.destroy();
    }
    if (newItem.chaptersLoc) {
      this.#rmp.chaptersLoc = newItem.chaptersLoc;
    } else if (this.#rmp.rmpChapters) {
      this.#rmp.rmpChapters.destroy();
    }
    const hasInitLogo = this.#rmp.dom.container.querySelector('.rmp-logo');
    if (newItem.logo) {
      this.#rmp.logoConfiguration = newItem.logo;
    } else if (hasInitLogo) {
      this.#rmp.logo.imgUri = '';
      this.#rmp.logoConfiguration = this.#rmp.logo;
    }
    if (newItem.sharingUrl) {
      this.#rmp.sharingData = {
        url: newItem.sharingUrl,
        code: ''
      };
    }
    if (newItem.sharingCode) {
      this.#rmp.sharingData = {
        url: '',
        code: newItem.sharingCode
      };
    }
  }

  #appendPlaylistItem(index) {
    // wrapper
    if (this.#filteredPlaylistList[index]) {
      const item = this.#filteredPlaylistList[index];
      const div = FW.createElement('div', 'rmp-playlist-item');
      this.#rmp.rmpAccessible.button(div, item.contentMetadata.title, true, 'playlist');
      // number
      const number = FW.createElement('div', 'rmp-playlist-item-number', (index + 1).toString());
      div.appendChild(number);
      // thumbnail
      const imgWrapper = FW.createElement('div', 'rmp-playlist-item-thumbnail-wrapper');
      const img = FW.createElement('img', 'rmp-playlist-item-thumbnail');
      img.alt = '';
      img.src = item.contentMetadata.thumbnail;
      imgWrapper.appendChild(img);
      div.appendChild(imgWrapper);
      // text area
      const textArea = FW.createElement('div', 'rmp-playlist-item-text-area');
      const rtl = this.#rmp.rtl;
      // title
      const title = FW.createElement('div', 'rmp-playlist-item-title', null, rtl);
      title.innerHTML = item.contentMetadata.title;
      textArea.appendChild(title);
      // description
      const description = FW.createElement('div', 'rmp-playlist-item-description', null, rtl);
      description.innerHTML = item.contentMetadata.description;
      textArea.appendChild(description);
      div.appendChild(textArea);

      // wire UI
      div.addEventListener('click', this.loadPlaylistItem.bind(this, index));
      // append to overlay
      this.#rmp.dom.playlistSideMenu.appendChild(div);
    }
  }

  #arrowInteraction(next, event) {
    FW.eventStopPrevent(event);
    let newIndex = this.#currentPlaylistIndex - 1;
    if (next) {
      newIndex = this.#currentPlaylistIndex + 1;
    }
    this.loadPlaylistItem(newIndex);
  }

  #addPlaylistNavigationArrows() {
    const hintLabel = this.#rmp.labels.hint;
    const playlistLeftArrow = FW.createElement(
      'button',
      'rmp-button rmp-playlist-left-arrow rmp-color-bg rmp-i rmp-i-previous',
      null,
      null
    );
    this.#rmp.rmpAccessible.button(playlistLeftArrow, hintLabel.previousItem, true);
    this.#rmp.dom.container.appendChild(playlistLeftArrow);

    const leftArrowInteraction = this.#arrowInteraction.bind(this, false);
    FW.addEvents(['touchend', 'click'], playlistLeftArrow, leftArrowInteraction);

    const playlistRightArrow = FW.createElement(
      'button',
      'rmp-button rmp-playlist-right-arrow rmp-color-bg rmp-i rmp-i-next',
      null,
      null
    );
    this.#rmp.rmpAccessible.button(playlistRightArrow, hintLabel.nextItem, true);
    this.#rmp.dom.container.appendChild(playlistRightArrow);

    const rightArrowInteraction = this.#arrowInteraction.bind(this, true);
    FW.addEvents(['touchend', 'click'], playlistRightArrow, rightArrowInteraction);
  }

  #updateSideMenuMaxHeight() {
    this.#rmp.dom.playlistSideMenu.style.maxHeight = this.#rmp.getPlayerSize().height + 'px';
    this.#rmp.dom.playlistSideMenu.classList.remove('rmp-xs', 'rmp-sm', 'rmp-md');
    if (this.#rmp.dom.container.classList.contains('rmp-md')) {
      this.#rmp.dom.playlistSideMenu.classList.add('rmp-md');
    } else if (this.#rmp.dom.container.classList.contains('rmp-sm')) {
      this.#rmp.dom.playlistSideMenu.classList.add('rmp-sm');
    } else if (this.#rmp.dom.container.classList.contains('rmp-xs')) {
      this.#rmp.dom.playlistSideMenu.classList.add('rmp-xs');
    }
  }

  #setUpPlaylistUI() {
    this.#rmp.dom.container.classList.add('rmp-playlist-ui');
    // add side arrows
    this.#addPlaylistNavigationArrows();
    const classNames = `rmp-playlist-side-menu rmp-color-button rmp-${this.#rmp.skin}`;
    this.#rmp.dom.playlistSideMenu = FW.createElement('div', classNames);
    const playlistHeader = FW.createElement(
      'div',
      'rmp-playlist-header',
      this.#rmp.labels.hint.playlist,
      this.#rmp.rtl
    );
    this.#rmp.dom.playlistSideMenu.appendChild(playlistHeader);
    for (let i = 0, len = this.#filteredPlaylistList.length; i < len; i++) {
      this.#appendPlaylistItem(i);
    }
    this.#rmp.dom.playlistContainer.appendChild(this.#rmp.dom.playlistSideMenu);
    // set max height for rmp-playlist-side-menu
    this.#updateSideMenuMaxHeight();
    this.#rmp.on('resize', this.#updateSideMenuMaxHeight.bind(this));
    // start at 0 index in playlist
    this.#updatePlaylistActiveUI(0);
  }

  #initialPlaylistParsing(playlist) {
    this.#filteredPlaylistList = ListHelpers.filterList(playlist);
    if (this.#filteredPlaylistList.length > 0 && this.#filteredPlaylistList[0]) {
      ListHelpers.initialListParsing.call(this.#rmp, this.#filteredPlaylistList[0]);
      this.#playlistOnSrcChangedLoadAdFn = this.#playlistOnSrcChangedLoadAd.bind(this);
      this.#playlistOnSrcChangeErrorFn = this.#playlistOnSrcChangeError.bind(this);
      this.#rmp.rmpUtils.detectSrc();
      this.#rmp.rmpInitManagement.selectStreamingProtocol();
      this.#setUpPlaylistUI();
    } else {
      this.#rmp.rmpUtils.error(703);
      this.#rmp.rejectPromise('init', this.#rmp.errorData);
    }
  }

  #updatePlaylist(playlist, resolve, reject) {
    this.#filteredPlaylistList = ListHelpers.filterList(playlist);
    if (this.#filteredPlaylistList.length > 0 && this.#filteredPlaylistList[0]) {
      // clear playlist side menu
      if (this.#rmp.dom.playlistSideMenu) {
        const playlistItems = this.#rmp.dom.playlistSideMenu.querySelectorAll('.rmp-playlist-item');
        if (playlistItems.length > 0) {
          for (let i = 0, len = playlistItems.length; i < len; i++) {
            FW.removeElement(playlistItems[i]);
          }
        }
        // repopulate side menu
        for (let i = 0, len = this.#filteredPlaylistList.length; i < len; i++) {
          this.#appendPlaylistItem(i);
        }
        this.loadPlaylistItem(0);
        resolve();
      }
    } else {
      this.#rmp.rmpUtils.error(703);
      reject(this.#rmp.errorData);
    }
  }

  playlistCallbackPromise() {
    return new Promise((resolve, reject) => {
      this.#rmp.playlistCallback().then(() => {
        Logger.print('playlist', 'playlistCallback has resolved');
        resolve();
      }).catch(warning => {
        this.#rmp.rmpUtils.warning(7000, warning);
        reject(this.#rmp.warningData);
      });
    });
  }

  loadPlaylistItem(index, event) {
    if (event) {
      event.stopPropagation();
    }
    Logger.print('playlist', 'request to load playlist item at index ' + index);
    if (this.#rmp.changingSrc) {
      Logger.print('playlist', 'previous item currently loading or linear ad on stage - new request is aborted');
      return;
    }
    const currentIndex = this.#currentPlaylistIndex;
    if (index === currentIndex) {
      return;
    }
    if (this.#rmp.playlistCallback !== null) {
      this.playlistCallbackPromise().then(() => {
        this.#loadInternalPlaylistItem(index);
      }).catch(warning => {
        console.warn(warning);
        this.#loadInternalPlaylistItem(index);
      });
    } else {
      this.#loadInternalPlaylistItem(index);
    }
  }

  setInternalPlaylistData(playlistData) {
    return new Promise((resolve, reject) => {
      if (Array.isArray(playlistData)) {
        this.#updatePlaylist(playlistData, resolve, reject);
      } else if (typeof playlistData === 'string') {
        this.#rmp.playlistLoc = playlistData;
        FW.ajax(this.#rmp.playlistLoc, this.#rmp.ajaxWithCredentials, 'GET').
          then(data => {
            Logger.print('playlist', 'loaded new JSON playlist at ' + this.#rmp.playlistLoc);
            let jsonData;
            try {
              jsonData = JSON.parse(data);
            } catch (error) {
              this.#rmp.rmpUtils.error(701, error);
              reject(this.#rmp.errorData);
              return;
            }
            if (Array.isArray(jsonData.playlist)) {
              this.#updatePlaylist(jsonData.playlist, resolve, reject);
            } else {
              this.#rmp.rmpUtils.error(702);
              reject(this.#rmp.errorData);
            }
          }).catch(error => {
            this.#rmp.rmpUtils.error(700, error);
            reject(this.#rmp.errorData);
          });
      }
    });
  }

  init() {
    if (this.#rmp.dom.containerParent.parentNode) {
      this.#rmp.dom.playlistContainer = this.#rmp.dom.containerParent.parentNode;
      this.#rmp.dom.playlistPlayerWrapper = this.#rmp.dom.playlistContainer.
        querySelector('.rmp-playlist-player-wrapper');
      if (this.#rmp.dom.playlistContainer.classList.contains('rmp-playlist-container') &&
        this.#rmp.dom.playlistPlayerWrapper) {
        if (this.#rmp.playlistLoc === '') {
          this.#initialPlaylistParsing(this.#rmp.playlistData);
        } else {
          FW.ajax(this.#rmp.playlistLoc, this.#rmp.ajaxWithCredentials, 'GET').
            then(data => {
              Logger.print('playlist', 'loaded JSON playlist at ' + this.#rmp.playlistLoc);
              let jsonData;
              try {
                jsonData = JSON.parse(data);
              } catch (error) {
                this.#rmp.rmpUtils.error(701, error);
                this.#rmp.rejectPromise('init', this.#rmp.errorData);
                return;
              }
              if (Array.isArray(jsonData.playlist)) {
                this.#initialPlaylistParsing(jsonData.playlist);
              } else {
                this.#rmp.rmpUtils.error(702);
                this.#rmp.rejectPromise('init', this.#rmp.errorData);
              }
            }).catch(error => {
              this.#rmp.rmpUtils.error(700, error);
              this.#rmp.rejectPromise('init', this.#rmp.errorData);
            });
        }
        return;
      }
    }
    this.#rmp.rmpUtils.error(704);
  }

}
